import { render, staticRenderFns } from "./TelegramIcon.vue?vue&type=template&id=55bf2a3e&scoped=true"
import script from "./TelegramIcon.vue?vue&type=script&lang=js"
export * from "./TelegramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bf2a3e",
  null
  
)

export default component.exports